import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import * as CopyText from '@segment/matcha/recipes/CopyText'
import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'
import SignupButton from '@segment/matcha/recipes/SignupButton'

import { trackButtonClick } from '@segment/tracking/scripts'

import heroPng2x from './assets/Hero@2x.png'
import heroWebp from './assets/Hero.webp'
import heroWebp2x from './assets/Hero@2x.webp'

const copy = {
  heading: `Wilco can teach you how to implement Segment`,
  description: `Sometimes the best way to learn a new skill is to try it out firsthand. Come see how Wilco can provide you with an easy way to experiment with Segment!`,
  cta: {
    text: `Get started`,
    url: `https://app.wilco.gg/company/Twilio/Segment/play`,
  },
}

const Hero: FC<PropsWithChildren> = () => {
  return (
    <Wrapper>
      <StyledHero variant="2Col">
        <HeroRecipe.Copy>
          <CopyText.Heading variant="h1" tag="h1">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description variant="pLarge" tag="p">
            {copy.description}
          </CopyText.Description>
          <HeroRecipe.Form>
            <SignupButton
              // eslint-disable-next-line camelcase
              additionalParams={{ twilio_developer_offer: `1` }}
              href={copy.cta.url}
              onClick={() => trackButtonClick({ buttonText: copy.cta.text, targetUrl: copy.cta.url })}
            >
              {copy.cta.text}
            </SignupButton>
          </HeroRecipe.Form>
        </HeroRecipe.Copy>

        <HeroRecipe.Contents>
          <picture>
            <source type="image/webp" srcSet={`${heroWebp}, ${heroWebp2x} 2x`} />
            <HeroRecipe.Image width="600" height="640" src={heroPng2x} alt="Wilco Integration" loading="lazy" />
          </picture>
        </HeroRecipe.Contents>
      </StyledHero>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  background-color: ${({ theme }) => theme.palette.twilio.gray[100]};
`

const StyledHero = styled(HeroBase)`
  ${HeroRecipe.Wrapper} {
    align-items: start;
    padding-bottom: 0;
  }
`

export default Hero
